import React, { useMemo } from 'react'
import { Table } from 'antd'
import { CheckOutlined, CloseOutlined } from '@ant-design/icons'
import styled from 'styled-components'

import { isMatchStatus, StatusCapsule } from 'portal/lib/primitives'
import { DesignMatchCondition } from 'portal/store/designMatches/types'

export function DesignMatchConditionsTable({
  conditions
}: {
  conditions: DesignMatchCondition[]
}) {
  const columns = useMemo(
    () => [
      {
        title: 'Condition',
        dataIndex: 'condition',
        key: 'condition',
        width: '12rem'
      },
      { title: 'Required', dataIndex: 'required', key: 'required' },
      { title: 'Delivered', dataIndex: 'delivered', key: 'delivered' },
      { title: 'Note', dataIndex: 'note', key: 'note' },

      { title: 'Records', dataIndex: 'records', key: 'records', width: '5rem' },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        render: (status: string) => {
          const isMatch = isMatchStatus(status)
          const text = `${status || ''}`.trim().toLowerCase() || 'review'
          return (
            <StatusCapsule $isMatch={isMatch}>
              {isMatch ? <CheckOutlined /> : <CloseOutlined />}
              <span>{text}</span>
            </StatusCapsule>
          )
        },
        width: '6.5rem'
      }
    ],
    []
  )

  return (
    <ConditionsTableContainer>
      <Table
        id="DesignMatchConditionsTable"
        columns={columns}
        dataSource={conditions}
        rowKey="id"
        pagination={false}
        size="small"
        locale={{ emptyText: 'No conditions' }}
      />
    </ConditionsTableContainer>
  )
}

const ConditionsTableContainer = styled.div`
  margin: 0.25rem 1rem 1rem 0;
`
